module.exports = __webpack_public_path__ + "img/znzlz.a45f9561.png";